import React, { createContext, useContext, useState } from "react";

const MenuContext = createContext();

export const useMinimized = () => {
  return useContext(MenuContext);
};

export const MenuProvider = ({ children }) => {
  const [isMinimized, setIsMinimized] = useState(true);
  const [isDrawerOpen, setDrawerOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [nestedAnchorEl, setNestedAnchorEl] = useState(null);
  const [openSubMenu, setOpenSubMenu] = useState(null);
  const [nestedOpenSubMenu, setNestedOpenSubMenu] = useState(null);
  
  return (
    <MenuContext.Provider
      value={{
        isMinimized, 
        setIsMinimized, 
        isDrawerOpen, 
        setDrawerOpen, 
        anchorEl, 
        setAnchorEl, 
        openSubMenu, 
        setOpenSubMenu,
        nestedAnchorEl,
        setNestedAnchorEl,
        nestedOpenSubMenu,
        setNestedOpenSubMenu
      }}>
      {children}
    </MenuContext.Provider>
  );
};
